export type CssLengthUnit =
    | ''
    | 'px'
    | '%'
    | 'em'
    | 'rem';

export type CssLengthParts =
{
    value: string
    unit: CssLengthUnit
}

const units: CssLengthUnit[] = ['px', '%', 'em', 'rem'];

export function parseCssLength(input?: string): CssLengthParts
{
    const value = (input ?? '').trim();

    if (!value) { return { value: '', unit: '' }; }

    for (const unit of units)
    {
        if (value.endsWith(unit))
        {
            return { value: value.slice(0, -unit.length).trim(), unit };
        }
    }

    return { value, unit: '' };
}

export function formatCssLength(value?: string, unit?: CssLengthUnit): string | null
{
    const trimmed = (value ?? '').trim();

    if (!trimmed) {
        return null;
    }

    return `${trimmed}${unit ?? ''}`;
}

export function parseTwoValueCssLength(input?: string): { first: CssLengthParts; second: CssLengthParts; }
{
    const parts = (input ?? '').trim().split(/\s+/).filter(Boolean);
    return { first: parseCssLength(parts[0]), second: parseCssLength(parts[1] ?? parts[0]) };
}

export function formatTwoValueCssLength
(
    firstValue?: string,
    firstUnit?: CssLengthUnit,
    secondValue?: string,
    secondUnit?: CssLengthUnit
)
: string | null
{
    const first = formatCssLength(firstValue, firstUnit);
    const second = formatCssLength(secondValue, secondUnit);

    if (!first && !second) { return null; }
    if (first && second) { return `${first} ${second}`; }
    return first ?? second;
}